export default {
  s3_with_param: "https://flipnet-assets.s3.sa-east-1.amazonaws.com/{value}",
  mission_targets:
    "https://flipnet-assets.s3.sa-east-1.amazonaws.com/admin/public/mission/assets/icons/{value}.png",
  
};
